export default __webpack_public_path__ + "static/media/logo23.e2a93600.svg";